// extracted by mini-css-extract-plugin
export default {"newNotification":"HotNotification_newNotification__BlT5f"};